import React from 'react';

import {useSelector} from '@xstate/react';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useBookingMachine} from '../../hooks/useBookingMachine';
import {BrandButton} from '../../lib/brand-button/brand-button';

import css from './booking-notify-host-button.css';


export const BookingNotifyHostButton = () => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();

  const currentSequenceNumber = useSelector(
    bookingActor,
    (state) => state.context.currentSequenceNumber ?? 0,
  );

  const handleGoBack = () => {
    bookingActor.send({type: 'day.prev'});
  };
  const handleNotifyHost = () => {
    bookingActor.send({type: 'notifyHost.go'});
  };

  const displaySequenceNumberPlusOne = currentSequenceNumber + 1;

  return (
    <EmptyState
      imageVariant="calendar"
      title={t(
        'No_available_date_time_found',
        'No available date & time found',
      )}
      description={
        currentSequenceNumber === 0
          ? t(
              'Please_notify_the_host_of_this_meeting_that_there_are_no_available_time_slots',
              'Please notify the host of this meeting that there are no available time slots',
            )
          : t(
              `You can either choose a different date for Day {{currentSequenceNumber}} or notify the host to create availability for Day {{displaySequenceNumberPlusOne}}.`,
              {
                currentSequenceNumber,
                displaySequenceNumberPlusOne,
              },
            )
      }
    >
      <div className={css.buttonContainer}>
        {currentSequenceNumber > 0 && (
          <Button
            type="tertiary"
            size="medium"
            iconLeftName="chevron-left"
            onClick={handleGoBack}
          >
            {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
            {t('Day', 'Day')} {currentSequenceNumber}
          </Button>
        )}
        <BrandButton onClick={handleNotifyHost}>
          {t('Notify_Host', 'Notify Host')}
        </BrandButton>
      </div>
    </EmptyState>
  );
};
